import { render, staticRenderFns } from "./DetalleTareasEnviadas.vue?vue&type=template&id=4d575952&scoped=true"
import script from "./DetalleTareasEnviadas.vue?vue&type=script&lang=js"
export * from "./DetalleTareasEnviadas.vue?vue&type=script&lang=js"
import style0 from "./DetalleTareasEnviadas.vue?vue&type=style&index=0&id=4d575952&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d575952",
  null
  
)

export default component.exports